"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[89238],{

/***/ 98899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var antd___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49288);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* eslint-disable react/jsx-props-no-spreading */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  cursor: auto;\n\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n  margin: ",
        ";\n  padding: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd___WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        filterOption: false,
        dropdownStyle: {
            border: "1px solid ".concat(_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro),
            boxShadow: "unset"
        },
        margin: props.margin,
        width: props.width || "100%",
        padding: props.padding,
        mt: props.mt,
        mb: props.mb,
        ml: props.ml,
        mr: props.mr,
        pt: props.pt,
        pb: props.pb,
        pl: props.pl,
        pr: props.pr
    };
}).withConfig({
    componentId: "sc-3205d83e-0"
})(_templateObject(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var mt = param.mt;
    return mt;
}, function(param) {
    var mb = param.mb;
    return mb;
}, function(param) {
    var ml = param.ml;
    return ml;
}, function(param) {
    var mr = param.mr;
    return mr;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var pt = param.pt;
    return pt;
}, function(param) {
    var pb = param.pb;
    return pb;
}, function(param) {
    var pl = param.pl;
    return pl;
}, function(param) {
    var pr = param.pr;
    return pr;
}));


/***/ }),

/***/ 89999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ HumbergerButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71577);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _hoc_withSpacing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97214);
/* eslint-disable react/jsx-props-no-spreading */ 



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      color: ",
        ";\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      color: ",
        ";\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        ,\n        :hover {\n          background: ",
        ";\n          color: ",
        ";\n        }\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border: none;\n    border-bottom: 1px solid ",
        ";\n    :hover,\n    :focus {\n      border-color: ",
        ";\n      color: ",
        ";\n    }\n\n    ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border-radius: ",
        ";\n    height: ",
        ";\n    margin: ",
        ";\n    padding: ",
        ";\n    \n    ::after{\n      content: unset;\n    }\n    \n    ",
        ";\n    border : ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background: ",
        ";\n      border-left: 1px solid ",
        ';\n      position: relative;\n      ::after {\n        content: "";\n        position: absolute;\n        bottom: 0;\n        width: 100%;\n        height: 2px;\n        background: ',
        ";\n      }\n      span:nth-child(1) {\n        transform: rotate(45deg);\n        position: relative;\n        top: 5px;\n      }\n      span:nth-child(2) {\n        display: none;\n      }\n      span:nth-child(3) {\n        transform: rotate(-45deg);\n        position: relative;\n        bottom: 0;\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  padding: 10px;\n  \n  span {\n    display: block;\n    height: 1px;\n    width: 16px;\n    background: ",
        ";\n    margin: 4px auto 0;\n    transition : 0.3s;\n  }\n  \n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}






var buttonType = {
    sunsetOrange: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].sunsetOrange */ .Z.sunsetOrange),
    highempahis: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis),
    defaultHoverable: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary),
    default: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro),
    primary: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary),
    widget: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject6(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis, function(param) {
        var active = param.active;
        return active && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject5(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].aliceBlue */ .Z.aliceBlue, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary);
    })
};
var ButtonCustom = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.memo((0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "round",
            "active",
            "borderLess"
        ].includes(prop);
    }
}).attrs(function(props) {
    return {
        height: props.height || "auto",
        type: props.type || "default",
        round: props.round,
        active: props.active,
        borderLess: props.borderLess,
        margin: props.margin || "0 !important",
        padding: props.padding || "4px 15px"
    };
}).withConfig({
    componentId: "sc-6d94ba47-0"
})(_templateObject7(), function(param) {
    var round = param.round;
    return round ? "2px" : "0px";
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var type = param.type;
    return buttonType[type];
}, function(param) {
    var borderLess = param.borderLess;
    return borderLess && "none";
}));
var HumbergerButtonComp = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    shouldForwardProp: function(props) {
        return ![
            "active"
        ].includes(props);
    }
}).attrs(function(props) {
    return {
        active: props.active
    };
}).withConfig({
    componentId: "sc-6d94ba47-1"
})(_templateObject9(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].dimgray */ .Z.dimgray, function(param) {
    var active = param.active;
    return active && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject8(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light);
});
var HumbergerButton = function(_param) /*#__PURE__*/ {
    var className = _param.className, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(HumbergerButtonComp, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        className: className
    }, otherProps), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {})
        ]
    }));
};

/* harmony default export */ __webpack_exports__["Z"] = ((0,_hoc_withSpacing__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ButtonCustom));


/***/ }),

/***/ 78587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  /* Antd Modal */\n  .ant-modal-header {\n    padding: 0 20px !important;\n    height: 40px;\n    border-color: ",
        ";\n  }\n  .ant-modal-content {\n    border-radius: 4px;\n  }\n  .ant-modal-body {\n    padding: 20px;\n  }\n  .ant-modal-footer {\n    padding: 0 !important;\n    text-align: left;\n    display: flex;\n  }\n  .ant-modal-close-x {\n    width: 40px;\n    height: 40px;\n    line-height: 40px;\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-81e0fb4c-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro));


/***/ }),

/***/ 48469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92961);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);
/* eslint-disable react/jsx-props-no-spreading */ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  width: ',
        ";\n\n  ",
        "\n\n  .ant-select-selector {\n    border: ",
        " !important;\n    border-color: ",
        " !important;\n    box-shadow: none !important;\n    height: inherit !important;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var Select = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        width: props.width,
        border: props.border || "1px solid"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-e69d6f89-0"
})(_templateObject1(), function(param) {
    var width = param.width;
    return width;
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}, function(param) {
    var border = param.border;
    return border;
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
/* harmony default export */ __webpack_exports__["Z"] = (Select);


/***/ }),

/***/ 8150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56266);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-71cb950b-0"
})(_templateObject()));


/***/ }),

/***/ 52211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ph": function() { return /* reexport safe */ _Select__WEBPACK_IMPORTED_MODULE_5__.Z; },
/* harmony export */   "iA": function() { return /* reexport safe */ _Table__WEBPACK_IMPORTED_MODULE_3__.Z; },
/* harmony export */   "kO": function() { return /* reexport safe */ _AutoSuggestion__WEBPACK_IMPORTED_MODULE_2__.Z; },
/* harmony export */   "zx": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89999);
/* harmony import */ var _Tooltip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8150);
/* harmony import */ var _AutoSuggestion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98899);
/* harmony import */ var _Table__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61166);
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78587);
/* harmony import */ var _Select__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48469);









/***/ }),

/***/ 89238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15807);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50489);








function FollowCompanyButton(_param) {
    var isFollowed = _param.isFollowed, onClick = _param.onClick, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "isFollowed",
        "onClick"
    ]);
    var iconName = isFollowed ? "icon-toolbar_check" : "icon-toolbar_plus";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_4__/* .ButtonFollow */ .qo, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        onClick: onClick,
        // @ts-expect-error
        $isFollowed: isFollowed,
        height: "30px",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_2__/* .IconWrapper */ .a, {
            padding: "0 12px 0 8px",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: iconName,
                    size: "14px",
                    isActive: isFollowed,
                    hoverColor: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highgray */ .Z.highgray
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    padding: "0 0 0 5px",
                    color: "inherit",
                    children: isFollowed ? "Following" : "Follow"
                })
            ]
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (FollowCompanyButton);


/***/ }),

/***/ 50489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AW": function() { return /* binding */ CountryFlag; },
/* harmony export */   "E": function() { return /* binding */ FollowerWrapper; },
/* harmony export */   "GT": function() { return /* binding */ CompanyIdentity; },
/* harmony export */   "Hr": function() { return /* binding */ CountryFlagContainer; },
/* harmony export */   "JQ": function() { return /* binding */ ButtonBuy; },
/* harmony export */   "Mw": function() { return /* binding */ ModalFollowing; },
/* harmony export */   "SD": function() { return /* binding */ NotationContainer; },
/* harmony export */   "U7": function() { return /* binding */ ExpandButtonToggleMobile; },
/* harmony export */   "WW": function() { return /* binding */ CatalogButton; },
/* harmony export */   "Y8": function() { return /* binding */ ButtonContainerMobile; },
/* harmony export */   "Yu": function() { return /* binding */ CompanyNameContainer; },
/* harmony export */   "ZE": function() { return /* binding */ NotationPopoverBadgeContainer; },
/* harmony export */   "Zc": function() { return /* binding */ ImagePlaceholder; },
/* harmony export */   "a9": function() { return /* binding */ Badges; },
/* harmony export */   "ag": function() { return /* binding */ CompanyHeader; },
/* harmony export */   "cr": function() { return /* binding */ CompanyTags; },
/* harmony export */   "dF": function() { return /* binding */ NotationCorpActionBarWrapper; },
/* harmony export */   "fb": function() { return /* binding */ ImageWrapper; },
/* harmony export */   "gv": function() { return /* binding */ NotationCountryFlagContainer; },
/* harmony export */   "mN": function() { return /* binding */ Symbol; },
/* harmony export */   "n4": function() { return /* binding */ CompanyInfoWrapper; },
/* harmony export */   "qO": function() { return /* binding */ ButtonContainer; },
/* harmony export */   "qo": function() { return /* binding */ ButtonFollow; },
/* harmony export */   "vo": function() { return /* binding */ CountryFlagContainerMobile; },
/* harmony export */   "zo": function() { return /* binding */ CompanyName; }
/* harmony export */ });
/* unused harmony exports Header, ColumnMobile, Percentage, Value, NewNotationTag, NewCorpActionTag, ModalFollowerWrapper, ModalFollowButtonWrapper, FollowerItemWrapper, FollowerModalByDevice, MultiplierContainer, MultiplierChip */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_company_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50550);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74575);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22147);
/* harmony import */ var global_CorpAction_CorpActionTag__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66988);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(579);
/* harmony import */ var global_Notation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15068);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19521);
/* harmony import */ var features_company_Chart_ExpandButtonToggle__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68068);
/* harmony import */ var global_Moderation_Modals_ModalCompanyWatchlist__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(38654);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  margin-bottom: 20px;\n  padding: 20px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  left: -1px;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  top: -1px;\n  width: calc(100% + 2px);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      /* TODO different color with DS */\n      border: 1px solid rgba(0, 171, 107, 0.5);\n      color: ",
        ";\n\n      &:hover {\n        border: 1px solid rgba(0, 171, 107, 0.5);\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 2px 8px;\n  width: 100px;\n\n  ",
        "\n\n  @media ",
        " {\n    padding: 4px 15px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n\n  @media ",
        " {\n    flex-direction: row;\n  }\n\n  &.start-center {\n    align-items: flex-start;\n\n    @media ",
        " {\n      align-items: center;\n    }\n  }\n\n  &.end-center {\n    align-items: flex-end;\n\n    @media ",
        " {\n      align-items: center;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media ",
        " {\n    margin-left: 5px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-transform: lowercase;\n  word-wrap: anywhere;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-radius: 70px;\n  color: ",
        ";\n  display: flex;\n  margin: auto;\n  min-height: 54px;\n  min-width: 54px;\n\n  > small {\n    font-family: 'Proxima Nova', sans-serif;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 27px;\n    margin: auto;\n    text-align: center;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  font-family: 'ProximaNovaBd';\n  font-size: 16px;\n  margin: 0;\n  max-width: calc(100% - 30px);\n  overflow: hidden;\n  padding: 0;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 50%;\n  display: none;\n  height: 18px;\n  margin-left: 10px;\n  width: 18px;\n\n  @media ",
        " {\n    display: inline-block;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  height: 24px;\n  width: 24px;\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 2px;\n  display: inline-block;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: normal;\n  position: relative;\n  top: -4px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  /* TODO different color with DS */\n  border: solid 1px rgba(238, 74, 73, 0.5);\n  border-radius: 2px;\n  color: ",
        ";\n  display: inline-block;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: normal;\n  margin-left: 8px;\n  padding: 0px 5px;\n  position: relative;\n  top: -5px;\n  vertical-align: middle;\n\n  > span {\n    font-style: normal;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 5px;\n\n  > h1 {\n    color: ",
        ";\n    font-family: 'ProximaNovaRg';\n    font-size: 14px;\n    line-height: 15px;\n    margin: 0;\n    padding: 0;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 3px;\n  width: 100%;\n\n  span.catalogs {\n    display: inline-block;\n    font-family: 'ProximaNovaRg';\n    font-size: 16px;\n    font-weight: 700;\n    max-width: calc(100% - 30px);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  a {\n    color: ",
        ";\n    display: block;\n    font-size: 12px;\n    font-weight: normal;\n    max-width: 100%;\n    overflow: hidden;\n    padding-right: 7px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 0;\n  position: relative;\n\n  span.catalogs {\n    display: none;\n    margin-bottom: 5px;\n    margin-right: 5px;\n    text-align: center;\n  }\n\n  span:first-child {\n    display: inline-block;\n  }\n\n  a {\n    display: block;\n    font-weight: normal;\n    padding: 2px 0;\n  }\n\n  /* TODO different device type with DS */\n  @media (min-width: 1081px) {\n    /* TODO different color with DS */\n    span.catalogs {\n      border: 1px solid rgba(0, 171, 107, 0.3);\n      border-radius: 2px;\n      display: inline-block;\n      padding: 0 5px;\n    }\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n  margin: 0;\n  width: 100%;\n\n  @media ",
        " {\n    margin: auto;\n    width: auto;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: flex-start;\n  background: ",
        ";\n  border: none;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  gap: 15px;\n  height: auto;\n  line-height: 1.15;\n  min-height: 65px;\n  padding: ",
        ";\n  position: relative;\n\n  @media ",
        " {\n    align-items: center;\n    flex-direction: row;\n    width: calc(100% - 355px);\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  margin-left: 4px;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  margin-left: 4px;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  position: absolute;\n  top: 89px;\n  right: 20px;\n\n  @media ",
        " {\n    display: none;\n    position: relative;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          background-color: ",
        ";\n          flex-direction: column;\n\n          > a {\n            width: 100%;\n          }\n\n          @media ",
        " {\n            flex-direction: row;\n\n            > div {\n              flex-basis: ",
        ";\n            }\n\n            > a {\n              flex-basis: ",
        ";\n            }\n          }\n        "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          background-color: transparent;\n        "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    cursor: pointer;\n    display: block;\n    margin-right: 10px;\n\n    :hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 24px;\n  padding: unset;\n  width: 100px;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid transparent;\n  border-width: 1px 0;\n  padding: 10px 15px;\n\n  :hover {\n    border-color: ",
        ";\n  }\n\n  @media ",
        " {\n    padding: 10px 50px;\n  }\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media ",
        " {\n    .ant-modal-content {\n      width: 660px;\n    }\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: auto;\n\n  @media ",
        " {\n    width: 100px;\n  }\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  border: none;\n  background: #ffffff;\n\n  @media ",
        " {\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    min-height: 65px;\n    padding: 17.5px 20px 12.5px 0px;\n    width: 355px;\n  }\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  margin-left: 8px;\n  top: -5px;\n  position: relative;\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  border: 1px solid #8277f8;\n  border-radius: 2px;\n  height: 16px;\n  padding: 0 4.5px 0 2px;\n  color: #8277f8;\n  background-color: #f5f0ff;\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  top: -5px;\n  position: relative;\n  display: inline-block;\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}












var Header = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4f9b0e3-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light);
var CompanyHeader = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-f4f9b0e3-1"
})(_templateObject1());
// eslint-disable-next-line space-infix-ops
var CountryFlag = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4f9b0e3-2"
})(_templateObject2());
var ButtonFollow = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4f9b0e3-3"
})(_templateObject4(), function(props) {
    return(// @ts-expect-error
    props.$isFollowed && (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject3(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary));
}, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var ColumnMobile = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4f9b0e3-4"
})(_templateObject5(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var Percentage = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    size: "13px",
    family: "bold"
}).withConfig({
    componentId: "sc-f4f9b0e3-5"
})(_templateObject6(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var Value = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    size: "18px",
    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].black */ .Z.black,
    family: "bold"
}).withConfig({
    componentId: "sc-f4f9b0e3-6"
})(_templateObject7());
/* TODO different color with DS */ var IMAGE_PLACEHOLDER_COLOR = "#3A645C";
var ImagePlaceholder = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-f4f9b0e3-7"
})(_templateObject8(), IMAGE_PLACEHOLDER_COLOR, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light);
var Symbol = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-f4f9b0e3-8"
})(_templateObject9());
var NotationCountryFlagContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4f9b0e3-9"
})(_templateObject10());
var CountryFlagContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-f4f9b0e3-10"
})(_templateObject11(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].veryLightGrey */ .Z.veryLightGrey, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var CountryFlagContainerMobile = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(CountryFlagContainer).withConfig({
    componentId: "sc-f4f9b0e3-11"
})(_templateObject12(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var NotationContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4f9b0e3-12"
})(_templateObject13());
var Badges = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4f9b0e3-13"
})(_templateObject14(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].sunsetOrange */ .Z.sunsetOrange);
var CompanyName = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4f9b0e3-14"
})(_templateObject15(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].highgray */ .Z.highgray);
var CompanyNameContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-f4f9b0e3-15"
})(_templateObject16(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary);
var CompanyTags = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4f9b0e3-16"
})(_templateObject17());
var ImageWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4f9b0e3-17"
})(_templateObject18(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var CompanyInfoWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4f9b0e3-18"
})(_templateObject19(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light, function(props) {
    return(// @ts-expect-error
    props.$isIconAvailable ? "15px 10px 12px 20px" : "10px 10px 10px 20px");
}, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var NewNotationTag = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(global_Notation__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4f9b0e3-19"
})(_templateObject20());
var NewCorpActionTag = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(global_CorpAction_CorpActionTag__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4f9b0e3-20"
})(_templateObject21());
var ExpandButtonToggleMobile = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(features_company_Chart_ExpandButtonToggle__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4f9b0e3-21"
})(_templateObject22(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var NotationCorpActionBarWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4f9b0e3-22"
})(_templateObject25(), // @ts-expect-error
function(param) {
    var isCompanyStock = param.isCompanyStock, isBoth = param.isBoth;
    return isCompanyStock ? (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject23(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet, isBoth ? "50%" : "auto", isBoth ? "50%" : "auto") : (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject24());
});
var FollowerWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].midgray */ .Z.midgray,
    size: "12px"
}).withConfig({
    componentId: "sc-f4f9b0e3-23"
})(_templateObject26(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].midgray */ .Z.midgray);
var ModalFollowerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4f9b0e3-24"
})(_templateObject27());
var ModalFollowButtonWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4f9b0e3-25"
})(_templateObject28());
var FollowerItemWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-f4f9b0e3-26"
})(_templateObject29(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].aliceBlue */ .Z.aliceBlue, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var FollowerModalByDevice = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_company_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    type: "fullscreen"
}).withConfig({
    componentId: "sc-f4f9b0e3-27"
})(_templateObject30(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var ButtonBuy = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs({
    type: "primary",
    height: "30px",
    ml: "10px"
}).withConfig({
    componentId: "sc-f4f9b0e3-28"
})(_templateObject31(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var CompanyIdentity = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4f9b0e3-29"
})(_templateObject32(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro);
var ButtonContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4f9b0e3-30"
})(_templateObject33(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var ButtonContainerMobile = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(ButtonContainer).withConfig({
    componentId: "sc-f4f9b0e3-31"
})(_templateObject34(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var ModalFollowing = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(global_Moderation_Modals_ModalCompanyWatchlist__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).attrs({
    maskStyle: {
        backgroundColor: "rgba(0,0,0,0.8)"
    }
}).withConfig({
    componentId: "sc-f4f9b0e3-32"
})(_templateObject35());
var MultiplierContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4f9b0e3-33"
})(_templateObject36());
var MultiplierChip = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4f9b0e3-34"
})(_templateObject37());
var CatalogButton = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-f4f9b0e3-35"
})(_templateObject38());
var NotationPopoverBadgeContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4f9b0e3-36"
})(_templateObject39());


/***/ }),

/***/ 38654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modals_ModalCompanyWatchlist; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/lib/entities/watchlist/index.ts
var watchlist = __webpack_require__(14675);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/Moderation/Modals/styled.js
var styled = __webpack_require__(74673);
// EXTERNAL MODULE: ./src/@deprecated-ui/widget/index.js
var widget = __webpack_require__(52211);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Input.js
var Input = __webpack_require__(54325);
;// CONCATENATED MODULE: ./src/global/Moderation/Modals/ModalCompanyWatchlist/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: solid 1px ",
        ";\n  height: 1px;\n  margin: 10px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-input-suffix {\n    color: rgb(203, 203, 203);\n  }\n\n  input::placeholder {\n    color: ",
        ";\n    font-size: 15px !important;\n    font-family: var(--bold-font);\n    opacity: 0.3;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7fb3d52-0"
})(_templateObject(), color/* default.gainsboro */.Z.gainsboro);
var styled_Input = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-a7fb3d52-1"
})(_templateObject1(), color/* default.highgray */.Z.highgray);

;// CONCATENATED MODULE: ./src/global/Moderation/Modals/ModalCompanyWatchlist/CreateWatchlist.tsx













function CreateWatchlist(param) {
    var companyId = param.companyId, onAddWatchlist = param.onAddWatchlist;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(""), watchlistName = ref[0], setWatchlistName = ref[1];
    var ref1 = (0,react.useState)(false), visible = ref1[0], setVisible = ref1[1];
    (0,react.useEffect)(function() {
        return function() {
            setVisible(false);
            setWatchlistName("");
        };
    }, []);
    var handleOnChange = function(e) {
        setWatchlistName(e.target.value);
    };
    var handleSubmitWatchlistName = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var add, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e === null || e === void 0 ? void 0 : e.preventDefault();
                        if (!(watchlistName.length > 0)) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 4;
                        return dispatch(watchlist/* effects.addCompanyWatchlist */.Sz.addCompanyWatchlist({
                            name: watchlistName,
                            companyId: companyId
                        }));
                    case 4:
                        add = _ctx.sent;
                        data = add.payload.data;
                        if (data) {
                            setWatchlistName("");
                            if (onAddWatchlist) {
                                onAddWatchlist();
                            }
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmitWatchlistName(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleModalCancel = function() {
        setVisible(false);
    };
    var handleToggleForm = function() {
        setVisible(!visible);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        direction: "column",
        width: "100%",
        style: {
            gap: "10px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                style: {
                    gap: 8,
                    cursor: "pointer"
                },
                onClick: handleToggleForm,
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                            className: "icon-toolbar_plus",
                            color: color/* default.primary */.Z.primary,
                            hoverColor: color/* default.primary */.Z.primary
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "18px",
                        color: color/* default.primary */.Z.primary,
                        children: "Create New Watchlist"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: visible,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            onSubmit: handleSubmitWatchlistName,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Input, {
                                    id: "wl-name-modal",
                                    placeholder: "Name your watchlist",
                                    height: "40px",
                                    width: "100%",
                                    onChange: handleOnChange,
                                    value: watchlistName,
                                    suffix: "".concat(watchlistName.length, "/25"),
                                    maxLength: 25
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "submit",
                                    style: {
                                        display: "none"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            justify: "flex-end",
                            mt: "10px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(widget/* Button */.zx, {
                                    height: "40px",
                                    px: "24px",
                                    borderLess: true,
                                    onClick: handleModalCancel,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: color/* default.primary */.Z.primary,
                                        children: "CANCEL"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(widget/* Button */.zx, {
                                    type: "primary",
                                    height: "40px",
                                    px: "24px",
                                    onClick: handleSubmitWatchlistName,
                                    style: {
                                        borderRadius: "3px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: color/* default.light */.Z.light,
                                        align: "center",
                                        children: "CREATE"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var ModalCompanyWatchlist_CreateWatchlist = (CreateWatchlist);

// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
;// CONCATENATED MODULE: ./src/global/Moderation/Modals/ModalCompanyWatchlist/SkeletonList.tsx



function SkeletonList() {
    var listItem = new Array(3).fill(0);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        direction: "column",
        justify: "center",
        align: "center",
        width: "100%",
        style: {
            gap: 10
        },
        children: listItem.map(function(_, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Input */.Z.Input, {
                active: true,
                size: "small",
                style: {
                    width: 470,
                    height: "30px"
                }
            }, "watchlist-skeleton-".concat(idx));
        })
    });
}
/* harmony default export */ var ModalCompanyWatchlist_SkeletonList = (SkeletonList);

;// CONCATENATED MODULE: ./src/global/Moderation/Modals/ModalCompanyWatchlist/index.tsx



















function ModalCompanyWatchlist(_param) {
    var companyId = _param.companyId, visible = _param.visible, onCancel = _param.onCancel, _onFollow = _param.onFollow, onFollow = _onFollow === void 0 ? function() {} : _onFollow, props = (0,_object_without_properties/* default */.Z)(_param, [
        "companyId",
        "visible",
        "onCancel",
        "onFollow"
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(watchlist/* selectors */.wl), _symbol = ref.symbol, watchlistCompany = _symbol.data, isLoading = _symbol.isLoading, error = _symbol.error;
    var ref1 = (0,react.useState)(0), currentCompanyId = ref1[0], setCurrentCompanyId = ref1[1];
    var watchListData = watchlistCompany[currentCompanyId] || [];
    (0,react.useEffect)(function() {
        if (companyId !== currentCompanyId) {
            dispatch(watchlist/* effects.getCompanyWatchlist */.Sz.getCompanyWatchlist(companyId));
            setCurrentCompanyId(companyId);
        }
    }, [
        companyId
    ]);
    var handleFollow = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(id, followed, index) {
            var type, params, follow, _payload, error, data, statusFollowing;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        type = followed ? "UNFOLLOW" : "FOLLOW";
                        params = {
                            companyId: companyId,
                            watchlistId: id,
                            type: type
                        };
                        _ctx.next = 4;
                        return dispatch(watchlist/* effects.followCompany */.Sz.followCompany(params));
                    case 4:
                        follow = _ctx.sent;
                        _payload = follow.payload, error = _payload.error, data = _payload.data;
                        if (!error) {
                            // dispatch(watchlistEffects.getCompanyWatchlist(companyId));
                            if (onFollow) {
                                statusFollowing = type === "FOLLOW" ? true : index !== 0;
                                onFollow(statusFollowing);
                            }
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleFollow(id, followed, index) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Modal */.u_, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        // @ts-expect-error
        noBorder: true,
        visible: visible,
        onCancel: onCancel,
        centered: true,
        title: // eslint-disable-next-line react/jsx-wrap-multilines
        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            size: "18px",
            height: "52px",
            family: "bold",
            align: "center",
            color: color/* default.suvaGray */.Z.suvaGray,
            children: "Save to Watchlist"
        }),
        footer: null,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCompanyWatchlist_CreateWatchlist, {
                companyId: currentCompanyId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    maxHeight: 280,
                    height: "280px",
                    overflowY: "auto"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: !watchListData.length || isLoading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCompanyWatchlist_SkeletonList, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: !isLoading,
                        children: watchListData.map(function(param, idx) {
                            var id = param.watchlist_id, name = param.name, followed = param.followed;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                height: "40px",
                                align: "center",
                                justify: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "16px",
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        // @ts-expect-error
                                        p: "0px",
                                        type: followed ? "primary" : "default",
                                        onClick: function() {
                                            return handleFollow(id, followed, idx);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                                            padding: "3px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                                className: "icon-toolbar_".concat(followed ? "check" : "plus"),
                                                color: followed ? color/* default.light */.Z.light : color/* default.dimgray */.Z.dimgray,
                                                size: "14px",
                                                hoverColor: followed ? color/* default.light */.Z.light : color/* default.dimgray */.Z.dimgray
                                            })
                                        })
                                    })
                                ]
                            }, id);
                        })
                    })
                ]
            })
        ]
    }));
}
/* harmony default export */ var Modals_ModalCompanyWatchlist = (ModalCompanyWatchlist);


/***/ })

}]);